import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const rejectedInsuranceApplication: AnswerPathTreeNode = {
  path: 'rejectedInsuranceApplication',
  nodeId: NodeIds.rejectedInsuranceApplication,
};
